import { HttpClient, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { AppStates, AppStateService } from '../../Layout/appStateService';

@Injectable({ providedIn: 'root' })
export class SDHttpService {
    constructor(private readonly _appStateService: AppStateService,
                private readonly _httpClient: HttpClient) {
        this._appStateService.appState$.subscribe(x => this.appState = x);
    }

    appState: AppStates;
    timestampCheckPromise: Promise<void>;

    get(url: string, config?: any): Promise<any> {
        config = {
            ...(config || {}),
            ...{
                method: 'GET',
                url: url
            }
        };

        config.params = config.params || {};

        if (!config.cache) {
            config.params = { ...config.params, ...{ cacheBuster: Date.now() } };
        }

        return this._makeRequest(config);
    }

    post(url: string, data?: any, config?: any): Promise<any> {
        config = {
            ...(config || {}),
            ...{
                method: 'POST',
                url: url,
                body: data
            }
        };

        return this._makeRequest(config);
    }

    put(url: string, data?: any, config?: any): Promise<any> {
        config = {
            ...(config || {}),
            ...{
                method: 'PUT',
                url: url,
                body: data
            }
        };

        return this._makeRequest(config);
    }

    delete(url: string, config?: any): Promise<any> {
        config = {
            ...(config || {}),
            ...{
                method: 'DELETE',
                url: url
            }
        };

        return this._makeRequest(config);
    }

    deleteByEntity(url: string, data: any, config?: any): Promise<any> {
        config = {
            ...(config || {}),
            ...{
                method: 'DELETE',
                url: url,
                body: data,
                headers: { 'Content-Type': 'application/json' }
            }
        };

        return this._makeRequest(config);
    }

    patch(url: string, data?: any, config?: any): Promise<any> {
        config = {
            ...(config || {}),
            ...{
                method: 'PATCH',
                url: url,
                body: data
            }
        };

        return this._makeRequest(config);
    }

    initializeTimestampCheck(checkPromise: Promise<void>): void {
        this.timestampCheckPromise = checkPromise;
    }

    private async _makeRequest(config: any): Promise<any> {
        if (this.appState === this._appStateService.appStates.LoggedOut) {
            throw 'Cannot make web request when logged out';
        }

        if (config && config.params) {
            let newParams = new HttpParams();
            if (config.params instanceof HttpParams) {
                config.params.keys().forEach(key => {
                    const values = config.params.getAll(key);
                    if (values && values.length) {
                        values
                            .filter(x => x !== null && x !== undefined)
                            .forEach(x => {
                                newParams = newParams.append(key, x);
                            });
                    }
                });
            } else if (typeof config.params === 'object') {
                Object.keys(config.params).forEach(key => {
                    if (config.params[key] !== null && config.params[key] !== undefined) {
                        newParams = newParams.append(key, config.params[key]);
                    }
                });
            }
            config = { ...config, params: newParams };
        }

        if (this.timestampCheckPromise) {
            return this.timestampCheckPromise.then(() => lastValueFrom(this._httpClient.request(config.method, config.url, config)));
        } else {
            return lastValueFrom(this._httpClient.request(config.method, config.url, config))
        }
    }
}
